/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Where a playable ad runs. Renamed from HUB_* — an interstitial or embed widget was never Hub-specific.
 * @export
 */
export const PlayableAdPlacement = {
    PRE_GAME: 'PRE_GAME',
    POST_GAME: 'POST_GAME',
    QUEST_REWARD: 'QUEST_REWARD',
    SURFACE_INTERSTITIAL: 'SURFACE_INTERSTITIAL',
    PARTNER_EMBED: 'PARTNER_EMBED',
    EMBED_WIDGET: 'EMBED_WIDGET'
} as const;
export type PlayableAdPlacement = typeof PlayableAdPlacement[keyof typeof PlayableAdPlacement];


export function instanceOfPlayableAdPlacement(value: any): boolean {
    for (const key in PlayableAdPlacement) {
        if (Object.prototype.hasOwnProperty.call(PlayableAdPlacement, key)) {
            if (PlayableAdPlacement[key as keyof typeof PlayableAdPlacement] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PlayableAdPlacementFromJSON(json: any): PlayableAdPlacement {
    return PlayableAdPlacementFromJSONTyped(json, false);
}

export function PlayableAdPlacementFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlayableAdPlacement {
    return json as PlayableAdPlacement;
}

export function PlayableAdPlacementToJSON(value?: PlayableAdPlacement | null): any {
    return value as any;
}

export function PlayableAdPlacementToJSONTyped(value: any, ignoreDiscriminator: boolean): PlayableAdPlacement {
    return value as PlayableAdPlacement;
}

